import React from 'react';
import * as S from './style';

export const Footer = () => {
  return (
    <div>
      <S.Wrapper>
        <S.Text>
          <div>Contact Us</div>
          <div>대표자 전윤제 | yoon22095@gmail.com</div>
          <div>헬스 잇 | Prod By. SWYG</div>
          <div>© 2022 by Healtheat All rights reserved.</div>
        </S.Text>
      </S.Wrapper>
    </div>
  );
};
